"use client";

import React from "react";

const ImpactOfBruxism: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        The Impact of Nocturnal Teeth Grinding on Oral Health
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Nocturnal teeth grinding, or bruxism, is a common condition that affects people of all ages. While it may seem like a harmless habit, the constant pressure and friction can lead to significant damage over time. Your teeth are designed to withstand normal forces from chewing and biting, but the intense force generated during teeth grinding can cause microscopic cracks in your tooth enamel.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        These tiny cracks may not be visible to the naked eye, but they can allow bacteria to enter and infect the inner layers of your teeth, leading to decay and potentially requiring a root canal. Moreover, the constant clenching and grinding can strain the muscles and ligaments in your jaw, resulting in discomfort, headaches, and even TMJ disorders.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Ignoring bruxism can also lead to more severe consequences, such as accelerated tooth wear, loose teeth, or even tooth loss. It&#39;s essential to address this issue promptly to preserve your oral health and maintain a confident smile.
      </p>
    </div>
  );
};

export default ImpactOfBruxism;